var _defs, _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteFriend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2218 46.0026V42.447C45.2218 40.5611 44.4726 38.7523 43.139 37.4187C41.8054 36.0851 39.9967 35.3359 38.1107 35.3359H23.8885C22.0025 35.3359 20.1937 36.0851 18.8601 37.4187C17.5265 38.7523 16.7773 40.5611 16.7773 42.447V46.0026",
    stroke: "#613ED2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0017 28.2222C34.9291 28.2222 38.1128 25.0385 38.1128 21.1111C38.1128 17.1838 34.9291 14 31.0017 14C27.0744 14 23.8906 17.1838 23.8906 21.1111C23.8906 25.0385 27.0744 28.2222 31.0017 28.2222Z",
    stroke: "#613ED2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.3984,
    y: 12.6016,
    width: 12,
    height: 2.8,
    rx: 1.4,
    fill: "#613ED2",
    id: "rect2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 20,
    width: 12,
    height: 2.8,
    rx: 1.4,
    transform: "rotate(-90 47 20)",
    fill: "#613ED2",
    id: "rect3"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0705202
    },
    d: "m 29.336416,29.511721 c -2.624811,-0.538244 -4.803644,-2.212225 -6.011564,-4.618639 -0.360565,-0.718317 -0.686764,-1.739007 -0.796663,-2.492795 -0.133464,-0.915416 -0.05372,-2.564019 0.164217,-3.395085 0.400888,-1.528699 1.12634,-2.786343 2.262813,-3.922816 1.278654,-1.278654 2.736211,-2.061091 4.467593,-2.398268 0.833417,-0.162303 2.322341,-0.163516 3.137071,-0.0026 4.941866,0.976326 8.000407,5.819984 6.714352,10.633186 -0.376083,1.40753 -1.031071,2.574752 -2.047926,3.64951 -1.312015,1.386724 -2.933108,2.270754 -4.742672,2.586315 -0.826584,0.144144 -2.34631,0.125384 -3.147221,-0.03885 z m 2.503468,-2.822679 c 1.854635,-0.292612 3.385024,-1.409209 4.200515,-3.064765 0.470595,-0.95537 0.560284,-1.370782 0.555735,-2.573988 -0.0036,-0.961627 -0.01734,-1.061791 -0.23002,-1.681343 -0.251194,-0.731742 -0.458338,-1.123592 -0.905055,-1.712077 -0.822846,-1.08398 -2.132117,-1.871446 -3.510679,-2.111512 -0.595332,-0.103673 -1.81059,-0.05036 -2.402403,0.10539 -0.610267,0.160607 -1.622976,0.681333 -2.131467,1.095982 -1.555718,1.268607 -2.325373,3.370245 -1.963421,5.361363 0.54851,3.017381 3.388075,5.054068 6.386795,4.58095 z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0705202
    },
    d: "M 16.428099,47.415835 C 16.067856,47.33492 15.658491,47.000591 15.471955,46.63495 15.332758,46.362101 15.3287,46.260533 15.354592,43.697552 c 0.02638,-2.611074 0.02988,-2.665806 0.212674,-3.32472 0.888463,-3.2026 3.07583,-5.368323 6.329266,-6.266636 l 0.669942,-0.184979 8.137645,-0.02012 c 8.886614,-0.02197 8.701667,-0.02909 10.016992,0.385516 2.489295,0.784651 4.562133,2.794396 5.459471,5.293297 0.398546,1.109867 0.474255,1.705653 0.51746,4.072111 0.04704,2.576689 0.01652,2.822808 -0.410215,3.307602 -0.505406,0.574172 -1.237148,0.662081 -1.880063,0.225865 -0.60419,-0.409942 -0.608759,-0.432569 -0.656524,-3.251386 -0.03779,-2.230171 -0.05612,-2.516079 -0.190048,-2.964574 -0.307972,-1.031326 -0.684284,-1.69017 -1.381536,-2.418778 -0.730827,-0.763694 -1.58524,-1.265507 -2.688327,-1.578907 l -0.564161,-0.160284 -7.933526,2.21e-4 -7.933526,2.21e-4 -0.564162,0.160064 c -1.744344,0.494903 -3.007171,1.558533 -3.744092,3.153501 -0.439255,0.950711 -0.466948,1.160142 -0.514477,3.890826 l -0.04316,2.479978 -0.214692,0.305571 c -0.357198,0.5084 -0.959692,0.746803 -1.551429,0.613892 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0705202
    },
    d: "m 47.976276,19.88332 c -0.432305,-0.135961 -0.797777,-0.554476 -0.899857,-1.030457 -0.04108,-0.191534 -0.07469,-1.05922 -0.07469,-1.928191 v -1.579946 l -1.856805,-0.02092 -1.856806,-0.02092 -0.264805,-0.202099 c -0.847811,-0.647048 -0.757415,-1.828072 0.176385,-2.304461 0.247069,-0.126046 0.422763,-0.137948 2.036216,-0.137948 h 1.765815 v -1.583235 c 0,-1.9257283 0.04873,-2.2067794 0.452658,-2.6107068 0.62358,-0.6235807 1.589228,-0.5355733 2.068741,0.1885413 l 0.19363,0.2924012 0.02092,1.8564993 0.02092,1.8565 h 1.772714 c 1.668299,0 1.79111,0.0089 2.085057,0.151203 0.440621,0.213301 0.719469,0.666778 0.719469,1.170037 0,0.394936 -0.161886,0.807823 -0.397987,1.015053 -0.371492,0.326067 -0.49216,0.343475 -2.380772,0.343475 h -1.798481 l -0.02092,1.8565 -0.02092,1.856499 -0.19401,0.292975 c -0.33427,0.504783 -0.961047,0.723316 -1.546477,0.539196 z",
    id: "path5"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriend);
export default __webpack_public_path__ + "static/media/inviteFriend.65bf89a3a72bc4967d1cc253c03076eb.svg";
export { ForwardRef as ReactComponent };